// @flow
import React from 'react';
import {Input} from 'reactstrap'
import AbstractField from "./AbstractField";

/**
 * TextArea
 */
class TextareaField extends AbstractField {
    static PropTypes = {
        rows: React.PropTypes.number,   // počat řádek pro textareu
    };

    static defaultProps = {
        rows: 3
    };

    render() {
        // Ignore componentClass
        const {addonsBefore, addonsAfter, ...props} = this.props;

        const field = <Input
            type="textarea"
            {...props}
        />;

        return this.renderFieldWithAddons(field, null, null);
    }
}
export default TextareaField;
